// import React from 'react';
// import ReusableTabs from '../../../../pages/ReusableTabs';
// import MaterialReturn from './MaterialReturnToStore';
// import ContractorAnalysis from './ContractorAnalysis';
 
// const ReturnToStoreTabs = () => {
//   const tabs = [
//     { label: 'Material Assign & Return', component: <MaterialReturn /> },
//     { label: 'Contractor Analysis', component: <ContractorAnalysis /> },
//   ];
 
//   return (
//     <ReusableTabs
//       tabs={tabs}
//       defaultTab={0}
//       panelStyles={{ padding: '16px' }}
//     />
//   );
// };
 
// export default ReturnToStoreTabs;    

import React, { useState, useEffect } from 'react';
import ReusableTabs from '../../../../pages/ReusableTabs';
import MaterialReturn from './MaterialReturnToStore';
import ContractorAnalysis from './ContractorAnalysis';

const ReturnToStoreTabs = () => {
  const [canAssignAndReturn, setCanAssignAndReturn] = useState(false);

  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanAssignAndReturn(roles.includes("Material_Assign_and_Return"));
    }
  }, []);

  const tabs = [
    ...(canAssignAndReturn
      ? [{ label: 'Material Assign & Return', component: <MaterialReturn /> }]
      : []
    ),
    { label: 'Contractor Analysis', component: <ContractorAnalysis /> },
  ];

  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      panelStyles={{ padding: '16px' }}
    />
  );
};

export default ReturnToStoreTabs;